import { Outlet, useLocation } from "react-router";
import styled from "styled-components";
import { useAuth } from "./context/AuthContext";
import { getCompanyPhoto } from "./api/companyApi";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import { useIsCompact } from "./utils/useIsMobile";
import useOverflowDetector from "./utils/useOverflowDetector";

/**
 * UYGULAMA KABUĞU.
 *
 * Telefonda panelin kullanılamaz olmasının asıl sebebi tek tek sayfalar değil,
 * BURASIYDI: sidebar akışın içinde sabit 280px yer kaplıyordu, 390px'lik bir
 * ekranda içeriğe ~110px kalıyordu. Dar ekranda sidebar akıştan çıkıp içeriğin
 * ÜSTÜNE binen bir çekmeceye dönüyor; hamburger düğmesi zaten vardı, artık
 * daraltmak yerine çekmeceyi açıp kapatıyor.
 */
function App() {
  const { company, logout } = useAuth();
  const [companyLogo, setCompanyLogo] = useState<any>();
  const isCompact = useIsCompact();
  const location = useLocation();

  // Dar ekranda taşan kutuları konsola yazar (yalnızca geliştirme kipinde).
  useOverflowDetector();
  // Geniş ekranda açık, dar ekranda kapalı başlar.
  const [sidebarOpen, setSidebarOpen] = useState(!isCompact);

  const getPhoto = async (photoId: string | null, type: string) => {
    try {
      if (!photoId) return;
      const response: any = await getCompanyPhoto(photoId, type);
      const imgUrl = URL.createObjectURL(response.data);
      setCompanyLogo(imgUrl);
    } catch (error) {
      console.error(`Fetch error for ${type}:`, error);
    } finally {
    }
  };

  useEffect(() => {
    getPhoto(company?.hrPhoto, "hr");
    // eslint-disable-next-line
  }, [company]);

  // Kırılımı geçince o modun varsayılanına dön: pencereyi daraltan kullanıcıda
  // çekmece açık kalıp içeriği kapatmasın, genişletende de kapalı kalmasın.
  useEffect(() => {
    setSidebarOpen(!isCompact);
  }, [isCompact]);

  // Çekmece modunda gezinince kapansın. Menüden sayfa seçildiğinde çekmece açık
  // kalırsa kullanıcı gittiği sayfayı hiç göremiyor.
  useEffect(() => {
    if (isCompact) setSidebarOpen(false);
  }, [location.pathname, location.search, isCompact]);

  // Çekmece açıkken Esc ile kapat — arka plana dokunmak da kapatıyor (Backdrop).
  useEffect(() => {
    if (!isCompact || !sidebarOpen) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setSidebarOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isCompact, sidebarOpen]);

  return (
    <AppWrapper>
      <Sidebar
        sidebarOpen={sidebarOpen}
        isCompact={isCompact}
        companyLogo={companyLogo}
        onLogoutClick={logout}
      />

      {isCompact && sidebarOpen && (
        <Backdrop onClick={() => setSidebarOpen(false)} aria-hidden="true" />
      )}

      <ContentWrapper>
        <Navbar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          companyLogo={companyLogo}  
        />
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </AppWrapper>
  );
}

export default App;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: row;
  /* 100dvh: mobil tarayıcıda adres çubuğu görünürken 100vh ekrandan taşıyor,
     sayfanın altı adres çubuğunun arkasında kalıyordu. dvh desteklemeyen
     tarayıcı bir üstteki 100vh'de kalır. */
  height: 100vh;
  height: 100dvh;
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  /* Çekmecenin (200) altında, içeriğin üstünde. */
  z-index: 150;
  background: rgba(17, 24, 39, 0.45);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /* min-width: 0 — flex çocuğu varsayılan olarak içeriğinden dar olamaz;
     geniş bir tablo bütün kabuğu şişirip sayfayı yatay kaydırtıyordu. */
  min-width: 0;
  overflow: hidden;
`;

const MainContent = styled.main`
  flex-grow: 1;
  background: #f0f0f5;
  overflow-y: auto;
  
`;